<template>
	<div class="page-frame">
    <header class="w-100 d-flex justify-content-between align-items-center px-3 sticky-top">
      <div class="d-flex align-items-center">
        <router-link :to="this.paths.top">
          <img id="@/assets/OCX_logo_rgb-02" src="@/assets/OCX_logo_rgb-02.png" 
            srcset="@/assets/OCX_logo_rgb-02.png 224w"
            sizes="(max-width:500px) 30vw, 224px" />
        </router-link>
        <router-link :to="this.paths.top" class="text-decoration-none bg-warning text-white rounded-pill p-2">
          <b>カスタマーポータル</b>
        </router-link>
        <dev class="p-3">
          <button type="button" id="sidebarCollapse" class="navbar-btn" :class="{ 'active': isActive }"
            @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </dev>
      </div>
      <span class="user btn" @click="account"></span>
    </header>
		<div class="wrapper">
			<!-- Sidebar Holder -->
			<nav id="sidebar" :class="{ 'active': isActive }">
				<div class="sticky-top">
					<div class="sidebar-header">
            <h2>MENU</h2>
					</div>
					<ul class="list-unstyled components">
						<li>
							<a data-toggle="collapse" :aria-expanded="isShow[0] ? 'true' : 'false'"
								@click="toggleCollapse(0)"><b>情報照会</b></a>
							<ul class="list-unstyled collapse" :class="{ 'show': isShow[0] }">
								<li>
									<router-link :to="this.paths.company">企業情報</router-link>
								</li>
								<li>
									<router-link :to="this.paths.line">回線情報</router-link>
								</li>
							</ul>
						</li>
						<li v-if="showAccountInfoMenu()">
							<a data-toggle="collapse" :aria-expanded="isShow[2] ? 'true' : 'false'"
								@click="toggleCollapse(2)"><b>アカウント情報</b></a>
							<ul class="list-unstyled collapse" :class="{ 'show': isShow[2] }">
								<li v-if="showMenu(this.paths.employee)">
									<router-link :to="this.paths.employee">担当者情報</router-link>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</nav>

			<main class="w-100">
				<!-- Page Content Holder -->
				<div id="content">
					<slot name="mainPage"></slot>
				</div>
			</main>
		</div>
	</div>
</template>

<script>
  // @ is an alias to /src
  import {paths} from '@/common/const'
   
  export default {
    data() {
      return {
        classArr: ['list-unstyled', 'collapse', 'show'],
        isActive: false,
        isShow: [true, true, true],
        paths: paths,
      }
    },
    methods: {
      toggleCollapse(idx) {
        this.isShow[idx] = !this.isShow[idx]
      },
      toggleMenu() {
        this.isActive = !this.isActive
      },
      account() {
        this.$router.push(paths.account);
      },
      showMenu(path) {
        return !this.$router.getRoutes().find(
                      route => route.path === path
                    ).meta.bl.includes(this.$store.getters.getLoginUser.userRole)
      },
      showAccountInfoMenu() {
        return this.showMenu(paths.employee) 
      },
    },
  }
</script>

<style scoped>
#content {
  padding: 20px;
  min-height: 91.8vh;
  transition: all 0.3s;
}

/* ---------------------------------------------------
    HEADER STYLE
----------------------------------------------------- */
header{
  height: 80px;
  box-shadow: 0px 0px 5px 0px hsla(0, 0%, 7%, 0.3);
  background: #fff;
}

.navbar-btn {
  box-shadow: none;
  outline: none !important;
  border: none;
}

#sidebarCollapse {
  width: 40px;
  height: 40px;
  background: #f5f5f5;
}

#sidebarCollapse span {
  width: 80%;
  height: 2px;
  margin: 0 auto;
  display: block;
  background: #555;
  transition: all 0.8s cubic-bezier(0.810, -0.330, 0.345, 1.375);
  transition-delay: 0.2s;
}

#sidebarCollapse span:first-of-type {
  transform: rotate(45deg) translate(2px, 2px);
}

#sidebarCollapse span:nth-of-type(2) {
  opacity: 0;
}

#sidebarCollapse span:last-of-type {
  transform: rotate(-45deg) translate(1px, -1px);
}

#sidebarCollapse.active span {
  transform: none;
  opacity: 1;
  margin: 5px auto;
}

.user {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  background-color: #ddd;
  width: 1em;
  height: 1em;
  font-size: 50px;
  overflow: hidden;
}
.user::before,
.user::after {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background-color: #aaa;
  content: "";
}
.user::before {
  top: 0.15em;
  width: 0.4em;
  height: 0.4em;
}
.user::after {
  bottom: -0.4em;
  width: 0.8em;
  height: 0.8em;
}
.user:hover {
  border-color: #aaa;
}

/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */
.wrapper {
  display: flex;
  align-items: stretch;
  perspective: 1500px;
}

#sidebar ul li a {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

#sidebar {
  min-width: 355px;
  max-width: 355px;
  background: #fff;
  color: #000;
  transition: all 0.6s cubic-bezier(0.945, 0.020, 0.270, 0.665);
  transform-origin: bottom left;
}

#sidebar.active {
  margin-left: -355px;
  transform: rotateY(100deg);
}

#sidebar .sidebar-header {
  padding: 20px 30px 20px 30px;
  background: #fff;
  height: 80px;
}

#sidebar ul.components {
  border-bottom: 1px solid #f0f0f0;
}

#sidebar ul p {
  color: #000;
  padding: 10px;
}

#sidebar ul li a {
  padding: 10px;
  font-size: 1.1em;
  display: block;
  padding-left: 30px !important;
}

#sidebar ul li a:hover {
  color: #999;
  background: #f0f0f0;
}

#sidebar ul li.active>a,
a[aria-expanded="true"] {
  color: #000;
  background: #f0f0f0;
}

#sidebar ul li a[data-toggle="collapse"] {
  position: relative;
}

#sidebar ul li a[aria-expanded="false"]::before,
a[aria-expanded="true"]::before {
  content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
  display: block;
  position: absolute;
  right: 20px;
  font-size: 0.6em;
  transform: rotate(180deg);
}

#sidebar ul li a[aria-expanded="true"]::before {
  transform: rotate(90deg);
}

#sidebar ul ul a {
  font-size: 1.0em !important;
  padding-left: 50px !important;
  background: #fcfcfc;
}

/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */
@media (max-width: 768px) {
  #sidebar {
    margin-left: -355px;
    transform: rotateY(90deg);
  }
  
  #sidebar.active {
    margin-left: 0;
    transform: none;
  }
  
  #sidebarCollapse span:first-of-type,
  #sidebarCollapse span:nth-of-type(2),
  #sidebarCollapse span:last-of-type {
    transform: none;
    opacity: 1;
    margin: 5px auto;
  }
  
  #sidebarCollapse.active span {
    margin: 0 auto;
  }
  
  #sidebarCollapse.active span:first-of-type {
    transform: rotate(45deg) translate(2px, 2px);
  }
  
  #sidebarCollapse.active span:nth-of-type(2) {
    opacity: 0;
  }
  
  #sidebarCollapse.active span:last-of-type {
    transform: rotate(-45deg) translate(1px, -1px);
  }
}
</style>